// extracted by mini-css-extract-plugin
module.exports = {"avatar":"DLqf","sm":"DLbp","md":"DLbr","lg":"DLbt","xl":"DLqh","rounded":"DLqj"};